// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const RhinoSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'rhino-idle',
    metadata: {
      frames: {
        'rhino-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-idle-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/idle.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-idle': [
          'rhino-idle-0',
          'rhino-idle-1',
          'rhino-idle-2',
          'rhino-idle-3',
        ],
      },
    },
  },
  {
    name: 'rhino-walk',
    metadata: {
      frames: {
        'rhino-walk-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-walk-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/walk.png',
        size: {
          w: 896,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-walk': [
          'rhino-walk-0',
          'rhino-walk-1',
          'rhino-walk-2',
          'rhino-walk-3',
          'rhino-walk-4',
          'rhino-walk-5',
          'rhino-walk-6',
        ],
      },
    },
  },
  {
    name: 'rhino-attack1',
    metadata: {
      frames: {
        'rhino-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-9': {
          frame: {
            x: 1152,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-10': {
          frame: {
            x: 1280,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-11': {
          frame: {
            x: 1408,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack1-12': {
          frame: {
            x: 1536,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/attack1.png',
        size: {
          w: 1664,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-attack1': [
          'rhino-attack1-0',
          'rhino-attack1-1',
          'rhino-attack1-2',
          'rhino-attack1-3',
          'rhino-attack1-4',
          'rhino-attack1-5',
          'rhino-attack1-6',
          'rhino-attack1-7',
          'rhino-attack1-8',
          'rhino-attack1-9',
          'rhino-attack1-10',
          'rhino-attack1-11',
          'rhino-attack1-12',
        ],
      },
    },
  },
  {
    name: 'rhino-attack2',
    metadata: {
      frames: {
        'rhino-attack2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack2-9': {
          frame: {
            x: 1152,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/attack2.png',
        size: {
          w: 1280,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-attack2': [
          'rhino-attack2-0',
          'rhino-attack2-1',
          'rhino-attack2-2',
          'rhino-attack2-3',
          'rhino-attack2-4',
          'rhino-attack2-5',
          'rhino-attack2-6',
          'rhino-attack2-7',
          'rhino-attack2-8',
          'rhino-attack2-9',
        ],
      },
    },
  },
  {
    name: 'rhino-attack3',
    metadata: {
      frames: {
        'rhino-attack3-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-9': {
          frame: {
            x: 1152,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-10': {
          frame: {
            x: 1280,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-11': {
          frame: {
            x: 1408,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-12': {
          frame: {
            x: 1536,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-13': {
          frame: {
            x: 1664,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-attack3-14': {
          frame: {
            x: 1792,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/attack3.png',
        size: {
          w: 1920,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-attack3': [
          'rhino-attack3-0',
          'rhino-attack3-1',
          'rhino-attack3-2',
          'rhino-attack3-3',
          'rhino-attack3-4',
          'rhino-attack3-5',
          'rhino-attack3-6',
          'rhino-attack3-7',
          'rhino-attack3-8',
          'rhino-attack3-9',
          'rhino-attack3-10',
          'rhino-attack3-11',
          'rhino-attack3-12',
          'rhino-attack3-13',
          'rhino-attack3-14',
        ],
      },
    },
  },
  {
    name: 'rhino-hit',
    metadata: {
      frames: {
        'rhino-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-hit-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-hit-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/hit.png',
        size: {
          w: 384,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-hit': ['rhino-hit-0', 'rhino-hit-1', 'rhino-hit-2'],
      },
    },
  },
  {
    name: 'rhino-dead',
    metadata: {
      frames: {
        'rhino-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-dead-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-dead-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-dead-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'rhino-dead-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/rhino/dead.png',
        size: {
          w: 640,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'rhino-dead': [
          'rhino-dead-0',
          'rhino-dead-1',
          'rhino-dead-2',
          'rhino-dead-3',
          'rhino-dead-4',
        ],
      },
    },
  },
];
